import { Component, Input, OnChanges } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-garmin-box',
  templateUrl: './garmin-box.component.html',
  styleUrls: ['./garmin-box.component.scss'],
})
export class GarminBoxComponent implements OnChanges {

  @Input() activity: Activity | Partial<Activity>;
  @Input() mapId = 'mapId';

  activityMinutes;

  constructor() { }

  ngOnChanges() {
    this.activityMinutes = Math.floor(this.activity.moving_time/60) +'\'';
  }

}
